// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"KeepReading__srOnly--I6YtP","hiddenInput":"KeepReading__hiddenInput--2DCG4","root":"KeepReading__root--tvbCm","arrow":"KeepReading__arrow--2tfPT"};